export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="relative rounded-2xl overflow-hidden aspect-[21/9] mb-8 md:mb-10">
          <img
            src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20still%20life%20product%20photography%20scene%20with%20a%20leather%20backpack%20a%20pair%20of%20trendy%20sunglasses%20a%20watch%20and%20a%20small%20perfume%20bottle%20arranged%20on%20a%20textured%20cream%20linen%20backdrop%20soft%20golden%20hour%20side%20lighting%20creating%20long%20elegant%20shadows%20magazine%20editorial%20vibe%20with%20warm%20amber%20tones%20and%20a%20cozy%20atmosphere&width=1400&height=600&seq=cta-v2-kakobuy-003&orientation=landscape"
            alt="Start exploring Kakobuy Spreadsheet today"
            className="w-full h-full object-cover rounded-2xl"
            loading="lazy"
          />
        </div>

        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
          Ready to Explore the <span className="text-primary-500 italic">Best</span> Kakobuy Spreadsheet?
        </h2>
        <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-8">
          Join thousands of smart shoppers who trust our <strong>Kakobuy Spreadsheet</strong> for verified finds, trusted sellers, and weekly updates.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 text-sm font-semibold rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Explore Full Spreadsheet
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 border-2 border-foreground-300 text-foreground-700 text-sm font-medium rounded-full hover:border-foreground-500 hover:text-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line text-sm"></i>
          </a>
        </div>
      </div>
    </section>
  );
}